// extracted by mini-css-extract-plugin
export default {"smallLogo":"style_smallLogo__58WlG","text":"style_text__6sOaS","loader":"style_loader__x8XNq","rotate":"style_rotate__691jd","prixClipFix":"style_prixClipFix__5r4au"};